<section class="agsec1">
    <div [innerHTML]="trustedBody"></div>
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="photo-grid">
                    <div *ngFor="let item of gallery" class="grid-item" (click)="openModal(item.position)">
                        <img [src]="item.path" class="img-fluid rounded" onerror="this.src='./assets/img/default.png'">
                        <div class="overlay">
                            <span>Ver imagen</span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>